import state from './moduleSgPeppolSubmissionsState.js'
import mutations from './moduleSgPeppolSubmissionsMutation.js'
import actions from './moduleSgPeppolSubmissionsActions.js'
import getters from './moduleSgPeppolSubmissionsGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
